import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { useTheme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import {
  Typography, TextField, MenuItem, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TablePagination, Paper, Divider, CircularProgress, Grid,
  List, ListItem, ListItemText, ListItemAvatar, Avatar, Tooltip, IconButton,
  Badge, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, Button
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";

const StyledTableCell2 = withStyles((theme) => ({
  head: {
    backgroundColor: "rgb(29, 95, 152)", //theme.palette.common.black,
    color: theme.palette.common.white,
    fontWeight: 500,
    border: "1px solid white",
  },
  body: {
    fontSize: 14,
    border: "1px solid rgb(29, 95, 152)",
  },
}))(TableCell);

const StyledTableRow2 = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

function CourseContentPopup(props) {
  const {
    classes,
    open,
    handleClose,
    label = "",
    filesName = [],
    recordId,
  } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Dialog
      maxWidth="md"
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <span style={{ color: "#ffffff" }}>
        _______________________________________________________________________________________________________________________
      </span>
      <DialogTitle style={{ paddingBottom: 0 }} id="responsive-dialog-title">
        <IconButton
          aria-label="close"
          onClick={handleClose}
          style={{
            position: "relative",
            top: "-35px",
            right: "-24px",
            float: "right",
          }}
          size="large">
          <CloseOutlinedIcon color="secondary" />
        </IconButton>
        <Typography
          style={{
            color: "#1d5f98",
            fontWeight: 600,
            borderBottom: "1px solid rgb(58, 127, 187, 0.3)",
            fontSize: 20,
          }}
        >
          {label}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          direction="row"
          alignItems="center"
          spacing={2}
          style={{
            marginTop: -10,
          }}
        >
          <Grid size={12}>
            <TableContainer component={Paper}>
              <Table
                className={classes.table}
                size="small"
                aria-label="customized table"
              >
                <TableHead>
                  <TableRow>
                    <StyledTableCell2
                      style={{ borderLeft: "1px solid rgb(29, 95, 152)" }}
                    >
                      File&nbsp;Name
                    </StyledTableCell2>
                    <StyledTableCell2 align="center">Download</StyledTableCell2>
                    <StyledTableCell2
                      align="center"
                      style={{ borderRight: "1px solid rgb(29, 95, 152)" }}
                    >
                      View
                    </StyledTableCell2>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filesName.length > 0 ? (
                    filesName.map((dt, i) => (
                      <StyledTableRow2 key={dt + i}>
                        <StyledTableCell2 component="th" scope="row">
                          {dt.fileName}
                        </StyledTableCell2>
                        <StyledTableCell2 align="center">
                          <Tooltip title="Download">
                            <IconButton
                              onClick={(e) =>
                                props.downloadFile(e, dt.fileSource)
                              }
                              aria-label="download"
                              size="large">
                              <CloudDownloadIcon color="primary" />
                            </IconButton>
                          </Tooltip>
                        </StyledTableCell2>
                        <StyledTableCell2 align="center">
                          <Tooltip title="Download">
                            <IconButton
                              onClick={(e) =>
                                props.downloadFile(e, dt.fileSource, true)
                              }
                              aria-label="download"
                              size="large">
                              <VisibilityOutlinedIcon color="primary" />
                            </IconButton>
                          </Tooltip>
                        </StyledTableCell2>
                      </StyledTableRow2>
                    ))
                  ) : (
                    <StyledTableRow key={1}>
                      <StyledTableCell component="th" scope="row" colSpan={6}>
                        <center>
                          <b>No Data</b>
                        </center>
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </DialogContent>
      <Divider
        style={{
          backgroundColor: "rgb(58, 127, 187)",
          opacity: "0.3",
        }}
      />
      <DialogActions>
        <Button autoFocus onClick={handleClose} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const StyledTableCell = withStyles((theme) => ({
  head: {
    //backgroundColor: "rgb(29, 95, 152)", //theme.palette.common.black,
    backgroundColor: "#f6f8fa",
    color: theme.palette.common.white,
    fontWeight: 500,
    //border: '1px solid rgb(29, 95, 152)',
    border: "1px solid #e1e4e8",
    borderRadius: "5px 5px 0px 0px",
    color: "rgb(29, 95, 152)",
  },
  body: {
    fontSize: 14,
    //border: '1px solid rgb(29, 95, 152)',
    border: "1px solid #f6f8fa",
    "&:hover": {
      cursor: "pointer",
    },
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      //backgroundColor: theme.palette.action.hover,
      "&:hover": {
        //backgroundColor:"#bdbdbd"
        backgroundColor: "#f6f8fa",
      },
    },
    "&:nth-of-type(even)": {
      "&:hover": {
        //backgroundColor:"#bdbdbd"
        backgroundColor: "#f6f8fa",
      },
    },
  },
}))(TableRow);

const styles = {
  table: {
    minWidth: 750,
    width: "100%",
  },
  tableContainer: {
    //maxHeight: 440,
  },
};

class F111FormTableComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showTableFilter: false,
      showSearchBar: false,
      isDownloadPdf: false,
      applicationStatusId: 1,
      isLoginMenu: false,
      isReload: false,
      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
      courseId: props.courseId ? props.courseId.split("T")[0] : "",
      name: props.courseId ? props.courseId.split("T")[1] : "",
      columns: [
        // {id: 'name', label: 'Name', minWidth: 170 },
        // {id: 'code', label: 'ISO\u00a0Code', minWidth: 100 },
        // {id: 'population', label: 'Population', minWidth: 170,  align:'right', format: (value) => value.toLocaleString('en-US')},
        // {id: 'size', label: 'Size\u00a0(km\u00b2)', minWidth: 170, align:'right', format: (value) => value.toLocaleString('en-US')},
        // {id: 'density', label: 'Density', minWidth: 170, align:'right', format: (value) => value.toFixed(2)},
      ],
      rows: [
        // this.createData('China', 'CN', 1403500365, 9596961),
        // this.createData('Italy', 'IT', 60483973, 301340),
        // this.createData('United States', 'US', 327167434, 9833520),
        // this.createData('Canada', 'CA', 37602103, 9984670),
        // this.createData('Australia', 'AU', 25475400, 7692024),
        // this.createData('Germany', 'DE', 83019200, 357578),
        // this.createData('Ireland', 'IE', 4857000, 70273),
        // this.createData('Mexico', 'MX', 126577691, 1972550),
        // this.createData('Japan', 'JP', 126317000, 377973),
        // this.createData('France', 'FR', 67022000, 640679),
        // this.createData('United Kingdom', 'GB', 67545757, 242495),
        // this.createData('Russia', 'RU', 146793744, 17098246),
        // this.createData('Nigeria', 'NG', 200962417, 923768),
        // this.createData('Brazil', 'BR', 210147125, 8515767),
      ],
      popupBoxOpen: false,
      page: 0,
      rowsPerPage: 10,
    };
  }

  handleOpenSnackbar = (msg, severity) => {
    this.setState({
      isOpenSnackbar: true,
      snackbarMessage: msg,
      snackbarSeverity: severity,
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ isOpenSnackbar: false });
  };

  handleClickOpen = (popupBoxLabel, popupBoxFiles) => {
    this.setState({
      popupBoxOpen: true,
      popupBoxLabel: popupBoxLabel,
      popupBoxFiles: popupBoxFiles,
    });
  };

  handleClose = () => {
    this.setState({
      popupBoxOpen: false,
      popupBoxFiles: [],
    });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value });
    this.setState({ page: 0 });
  };

  createData(name, code, population, size) {
    const density = population / size;
    return { name, code, population, size, density };
  }

  getData = async () => {
    this.setState({ isLoading: true });
    const courseId = this.props.courseId || 0;
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C112CommonAcademicsCourseContentView?courseId=${courseId}`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            this.setState({ rows: json.DATA || [] });
          } else {
            //alert(json.SYSTEM_MESSAGE + '\n' + json.USER_MESSAGE);
            this.handleOpenSnackbar(
              <span>
                {json.SYSTEM_MESSAGE}
                <br />
                {json.USER_MESSAGE}
              </span>,
              "error"
            );
          }
          console.log("getData", json);
        },
        (error) => {
          if (error.status === 401) {
            this.setState({
              isLoginMenu: true,
              isReload: false,
            });
          } else {
            //alert('Failed to fetch, Please try again later.');
            this.handleOpenSnackbar(
              "Failed to fetch, Please try again later.",
              "error"
            );
            console.log(error);
          }
        }
      );
    this.setState({ isLoading: false });
  };

  downloadFile = (e, fileName, viewOnly = false) => {
    e.preventDefault();
    const data = new FormData();
    data.append("fileName", fileName);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME
      }/common/CommonViewFile?fileName=${encodeURIComponent(fileName)}`;
    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (res.status === 200) {
          return res.blob();
        } else if (res.status === 401) {
          this.setState({
            isLoginMenu: true,
            isReload: false,
          });
          return {};
        } else {
          alert("Operation Failed, Please try again later.");
          return {};
        }
      })
      .then((result) => {
        if (viewOnly) {
          let fileExtension = fileName.slice(
            (Math.max(0, fileName.lastIndexOf(".")) || Infinity) + 1
          );
          let fileMimeType = result.type;
          if (fileExtension === "doc" || fileExtension === "DOC") {
            fileMimeType = "application/msword";
          } else if (fileExtension === "pdf" || fileExtension === "PDF") {
            fileMimeType = "application/pdf";
          } else if (fileExtension === "docx" || fileExtension === "DOCX") {
            fileMimeType =
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
          }
          let blob = new Blob([result], { type: fileMimeType });
          if (blob) {
            let fileURL = window.URL.createObjectURL(blob);
            window.open(fileURL);
          }
        } else {
          let csvURL = window.URL.createObjectURL(result);
          let tempLink = document.createElement("a");
          tempLink.href = csvURL;
          tempLink.setAttribute("download", fileName);
          tempLink.click();
        }

        if (result.CODE === 1) {
          //Code
        } else if (result.CODE === 2) {
          alert(
            "SQL Error (" +
            result.CODE +
            "): " +
            result.USER_MESSAGE +
            "\n" +
            result.SYSTEM_MESSAGE
          );
        } else if (result.CODE === 3) {
          alert(
            "Other Error (" +
            result.CODE +
            "): " +
            result.USER_MESSAGE +
            "\n" +
            result.SYSTEM_MESSAGE
          );
        } else if (result.error === 1) {
          alert(result.error_message);
        } else if (result.success === 0 && result.redirect_url !== "") {
          window.location = result.redirect_url;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  componentDidMount() {
    this.getData();
  }

  render() {
    const { classes } = this.props;

    const { columns, rows, isLoading } = this.state;

    return (
      <Fragment>
        <Paper className={classes.table}>
          <TableContainer className={classes.tableContainer}>
            <Table stickyHeader size="small" aria-label="sticky table">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell colSpan={6}>
                    <Typography component="span" variant="body1">
                      List
                    </Typography>
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {rows.length > 0 ? (
                  rows
                    .slice(
                      this.state.page * this.state.rowsPerPage,
                      this.state.page * this.state.rowsPerPage +
                      this.state.rowsPerPage
                    )
                    .map((row, i) => {
                      return (
                        <StyledTableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={"SCT" + i + row.id}
                        >
                          <StyledTableCell colSpan={6}>
                            <ListItem
                              onClick={() =>
                                this.handleClickOpen(
                                  row.sectionLabel + " - " + row.label,
                                  row.courseContentFileName
                                )
                              }
                            >
                              <ListItemAvatar>
                                <Avatar style={{ backgroundColor: "#f6f8fa" }}>
                                  <FolderOutlinedIcon color="primary" />
                                </Avatar>
                              </ListItemAvatar>
                              <ListItemText
                                primary={
                                  <Typography
                                    component="span"
                                    color="primary"
                                    style={{
                                      fontWeight: 600,
                                      fontSize: 18,
                                    }}
                                  >
                                    {row.label}
                                  </Typography>
                                }
                                secondary={
                                  <span>
                                    &nbsp;&mdash;&nbsp;by&nbsp;{row.createdBy}
                                    ,&nbsp;&nbsp;{row.createdOnReport}
                                  </span>
                                }
                              />
                              <Badge
                                color="secondary"
                                badgeContent={row.totalContentFile}
                                style={{ float: "right" }}
                              >
                                <Tooltip title="Number of replies">
                                  {/* <MailOutlineOutlinedIcon style={{color:"#b6babf"}} /> */}
                                  <FileCopyOutlinedIcon
                                    style={{ color: "#b6babf" }}
                                  />
                                </Tooltip>
                              </Badge>
                            </ListItem>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })
                ) : isLoading ? (
                  <StyledTableRow hover tabIndex={-1}>
                    <StyledTableCell colSpan={6} align="center">
                      <br />
                      <CircularProgress disableShrink />
                      &emsp;
                      <Typography color="primary" variant="body1">
                        Loading ...
                      </Typography>
                      <br />
                    </StyledTableCell>
                  </StyledTableRow>
                ) : (
                  <StyledTableRow hover tabIndex={-1}>
                    <StyledTableCell colSpan={6} align="center">
                      <br />
                      <Typography
                        color="primary"
                        variant="body1"
                        style={{ fontWeight: 600 }}
                      >
                        No Data
                      </Typography>
                      <br />
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={rows.length}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </Paper>
        <CourseContentPopup
          open={this.state.popupBoxOpen}
          handleClose={this.handleClose}
          classes={classes}
          label={this.state.popupBoxLabel}
          filesName={this.state.popupBoxFiles}
          downloadFile={this.downloadFile}
        />
      </Fragment>
    );
  }
}

F111FormTableComponent.propTypes = {
  courseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default withStyles(styles)(F111FormTableComponent);
